<div style="padding: 24px;background: #161616;">
    <!--    approve-->
    <div *ngIf="type == 'approve'">
        <div class="title">Are you sure to approve this EOI?</div>
        <div style="text-align: end">
            <button mat-flat-button class="cancel_button" (click)="close(false)">Cancel
            </button>
            <button mat-flat-button class="confirm_button" (click)="close(true)">Confirm</button>
        </div>
    </div>

    <div *ngIf="type != 'approve'">
        <mat-form-field appearance="outline" style="width: 500px">
            <textarea matInput [(ngModel)]="remark"
                placeholder="{{ type=='reject'?'The application is rejected because...':'The application is removed because...' }}"></textarea>
        </mat-form-field>

        <div style="text-align: end">
            <button mat-flat-button class="cancel_button" (click)="close(false)">Cancel
            </button>
            <button mat-flat-button class="confirm_button" (click)="close(true)">{{ type }}</button>
        </div>
    </div>


</div>